import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { orderBy, noop, get } from 'lodash-es';
import Download from 'sushiweb/Icons/all/Download';
import Search from 'sushiweb/Icons/all/Search';
import Layout from 'sushiweb/Layout/Layout';
import Spinner from 'sushiweb/Spinner/Spinner';
import Breadcrumb from 'sushiweb/Breadcrumb/Breadcrumb';
import red from 'sushiweb/tokens/color/red';
import H5 from 'sushiweb/Typography/Heading/H5';
import Tooltip from 'sushiweb/Tooltip/Tooltip';
import {
  exportCSV,
  filterCurrentData,
  formatAmountInRupees,
  formatDateinDDMMMYYY,
  formatReferenceIDForPayments,
  getCurrentDate,
  getMonthAndYearFromDate,
  getPeriodForInvoice,
  includesOption,
  indexOfOption,
  isCurrentMonth,
  isInvoiceGenerated,
  searchWithName,
  // zipFiles,
} from '../../../../helpers';
import {
  REFRESH_LABEL,
  applicableFlowTypes,
  currentFlowTypeEnum,
  currentMonthDiscountMSG,
  invoiceAmountPaidTooltip,
  invoiceAmountPayableTooltip,
  invoicePeriodTooltip,
  invoicesStatusEnum,
  paymentStatusEnum,
  sourceToCreditType,
  statusLabels,
} from '../../../common/components/constants';
import {
  BreadCrumbWrapper,
  CurrentMonthConsumptionDiscountGap,
  CurrentMonthConsumptionDiscountText,
  CurrentMonthConsumptionDiscountWrapper,
  CurrentMonthDiscountMsgIcon,
  DashboardWrapper,
  HeadWrapper,
  LayoutContainers,
  SearchContainerV2,
  SearchInput,
  SpinnerHolder,
  StatusFilterAndExportCSVContainer,
  StyledButton,
  TabWrapper,
  TableContainer,
} from '../../../common/styles';
import { StatusContainer } from '../../../common/components/DataTables/styles';
import DetailsWrapper from '../../../common/components/DetailsWrapper/DetailsWrapper';
import ErrorPage from '../../../common/components/ErrorPage';
import StatusFilter from '../../../common/components/StatusFilter';
import DataTables from '../../../common/components/DataTables/DataTables';
import { paymentsCreditsHeadColumn } from '../../../common/components/DataTables/components/headColumns';
import { DASHBOARD_ROUTE, HOME_ROUTE, PAYMENTS_ROUTE } from '../../../../constants/routes';
import { ActionComponentContainer } from '../../styles';
import OnlinePaymentModal from '../../../common/components/OnlinePaymentModal';
import {
  DiscountMsgIcon,
  DownloadInvoice,
  OnlinePaymentsIcon,
} from '../../../../components/SVGs/commonSVGs';
import { GET_INVOICE_FILES } from '../../../../constants/urls';
import zfetch from '../../../common/utils/zfetch';
import ZTrackingClient from '../../../../jumbo/ZTrackingClient';
import CreateReportModal from '../../../Reports/CreateReportModal';

const InvoiceDetails = ({
  currentFlow,
  invoiceDetails,
  appliedDiscount,
  getInvoiceDetails,
  fetchingInvoiceDetails,
  paymentsForInvoice,
  getPaymentsForInvoice,
  fetchingPaymentsForInvoice,
  fetchedPaymentsForInvoice,
  showErrorToast,
  clearGenerateReport,
  viewOnlyMode,
}) => {
  const keyFields = ['invoice_id'];
  const [currentPage, setCurrentPage] = useState(1);
  const [onlinePaymentModal, setOnlinePaymentModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [currentData, setCurrentData] = useState([]);
  const { startDate, endDate } = useParams();
  const [search, onInputChange] = useState('');
  const [typingTimeout, setTypingTimeout] = useState(0);
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentFilters, setCurrentFilters] = useState([]);
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [disabledSearch, setDisabledSearch] = useState(false);
  const [downloadingInvoice, setDownloadingInvoice] = useState(false);
  const [showCreateReportModal, setShowCreateReportModal] = useState(false);
  const isDiscountApplied =
    appliedDiscount?.request_id && appliedDiscount?.request_id !== '';
  const [filterStatusOptions, setFilterStatusOptions] = useState([
    {
      value: [0, 6],
      label: 'PENDING',
      disabled: true,
    },
    {
      value: [1, 4],
      label: 'SUCCESS',
      disabled: true,
    },
    {
      value: [2],
      label: 'DECLINED',
      disabled: true,
    },
    {
      value: [3, 5],
      label: 'FAILED',
      disabled: true,
    },
    {
      value: [7, 8],
      label: 'REFUNDED',
      disabled: true,
    },
  ]);

  const openOnlinePaymentModal = () => {
    setOnlinePaymentModal(true);
  };

  const closeOnlinePaymentModal = () => {
    setOnlinePaymentModal(false);
  };

  const generateZIP = () => {
    setDownloadingInvoice(true);
    zfetch(GET_INVOICE_FILES, {
      method: 'GET',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      params: {
        start_date: startDate,
        end_date: endDate,
        flow_type: currentFlow,
      },
    })
      .then(res => res.json())
      .then(res => {
        const data = get(res, 'data');
        window.open(get(data, 'invoice_file'), '_blank', 'noopener');
        setDownloadingInvoice(false);
      })
      .catch(error => {
        console.error(error);
        showErrorToast('Failed to download consumption statement');
        setDownloadingInvoice(false);
      });
  };
  const ActionComponent = () => {
    return (
      <ActionComponentContainer>
        {isInvoiceGenerated(invoiceDetails.status) ? (
          <div>
            <StyledButton
              icon={<DownloadInvoice />}
              iconAlign='right'
              appearance='outline'
              style={{
                fontWeight: 400,
                fontSize: '14px',
                color: red.z500,
                backgroundColor: red.z50,
              }}
              loading={downloadingInvoice}
              onClick={generateZIP}
            >
              Download statement
            </StyledButton>
          </div>
        ) : (
          <div>
            <StyledButton
              icon={<DownloadInvoice />}
              iconAlign='right'
              appearance='outline'
              style={{
                fontWeight: 400,
                fontSize: '14px',
                color: red.z500,
                backgroundColor: red.z50,
              }}
              loading={downloadingInvoice}
              onClick={() => setShowCreateReportModal(true)}
              disabled={viewOnlyMode}
            >
              Generate statement
            </StyledButton>
          </div>
        )}
        {invoiceDetails.status !== invoicesStatusEnum.PAID &&
          invoiceDetails.status !== invoicesStatusEnum.PAYMENT_PENDING &&
          invoiceDetails.status !== invoicesStatusEnum.PREPAYMENT_PENDING &&
          invoiceDetails.status !== invoicesStatusEnum.SETTLED_PAID &&
          invoiceDetails.status !== invoicesStatusEnum.KAM_APPROVAL_PENDING ? (
            <div>
              <StyledButton
                icon={<OnlinePaymentsIcon />}
                iconAlign='right'
                onClick={openOnlinePaymentModal}
                style={{ fontWeight: 400, fontSize: '14px' }}
              >
                Pay online
              </StyledButton>
            </div>
        ) : null}
      </ActionComponentContainer>
    );
  };
  const enableCurrentFilters = availableStatuses => {
    for (let i = 0; i < filterStatusOptions.length; i += 1) {
      for (let j = 0; j < filterStatusOptions[i].value.length; j += 1) {
        if (availableStatuses.includes(filterStatusOptions[i].value[j])) {
          filterStatusOptions[i].disabled = false;
          break;
        } else filterStatusOptions[i].disabled = true;
      }
    }
    setFilterStatusOptions(filterStatusOptions);
  };

  useEffect(() => {
    getInvoiceDetails({ startDate, endDate, flowType: currentFlow });
    getPaymentsForInvoice({ startDate, endDate, flowType: currentFlow });
  }, []);

  useEffect(() => {
    if (!fetchingPaymentsForInvoice && fetchedPaymentsForInvoice) {
      if (paymentsForInvoice.length) {
        paymentsForInvoice.sort(
          (a, b) => new Date(b.created_on) - new Date(a.created_on),
        );
        if (paymentsForInvoice.length === 0) {
          setDisabledSearch(true);
        }
        setTableData(paymentsForInvoice);
        setCurrentData(paymentsForInvoice.slice(0, 10));
      }
      setLoading(false);
    }
  }, [fetchingPaymentsForInvoice]);

  useEffect(() => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const timeout = setTimeout(() => {
      if (!fetchingPaymentsForInvoice) {
        const arr = searchWithName(paymentsForInvoice, search, keyFields);
        const availableStatuses = [];
        arr.forEach(data => {
          if (!availableStatuses.includes(data.status)) {
            availableStatuses.push(data.status);
          }
        });
        enableCurrentFilters(availableStatuses);
        if (currentFilters.length !== 0) {
          const filteredSearchArr = arr.filter(val =>
            filterCurrentData(val, currentFilters),
          );
          setSearchResults(filteredSearchArr);
        } else {
          setSearchResults(arr);
        }
        handlePageChange(1);
      }
    }, 500);

    return () => setTypingTimeout(timeout);
  }, [search, currentFilters, fetchingPaymentsForInvoice]);

  useEffect(() => {
    ZTrackingClient.recordImpression({
      ui_source: 'INVOICE_DETAILS',
      component: 'TABLE_DATA',
    });
  }, []);

  useEffect(() => {
    if (searchResults) {
      const start = currentPage * 10 - 10;
      const end = currentPage * 10;
      const rangeData = searchResults.slice(start, end);
      setCurrentData(rangeData);
    }
  }, [currentPage, searchResults]);

  useEffect(() => {
    if (tableData.length > 0) {
      const start = currentPage * 10 - 10;
      const end = currentPage * 10;
      const rangeData = tableData.slice(start, end);
      setCurrentData(rangeData);
    }
  }, [currentPage]);

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const handleSort = (column, sortDirection) => {
    setSearchResults(orderBy(searchResults, column.selector, sortDirection));
  };

  const refreshPage = () => {
    getPaymentsForInvoice({ startDate, endDate });
  };

  const exportSearchResultCSV = () => {
    const headColumns = [
      { key: 'created_on_val', value: 'Date' },
      { key: 'source_val', value: 'Payment type' },
      { key: 'reference_id_val', value: 'Reference no.' },
      { key: 'amount_val', value: 'Amount' },
      { key: 'status', value: 'Status' },
    ];
    const statusLabelledData = [];
    searchResults.forEach(data => {
      const labelledData = {};
      labelledData.created_on_val = formatDateinDDMMMYYY(data.created_on);
      labelledData.source_val = sourceToCreditType(data.source);
      labelledData.reference_id_val = formatReferenceIDForPayments(data);
      labelledData.amount_val = formatAmountInRupees(String(data.amount));
      labelledData.status = statusLabels[paymentStatusEnum[data.status]];
      statusLabelledData.push(labelledData);
    });
    exportCSV(
      statusLabelledData,
      `${invoiceDetails?.invoice_id
      } - Credit transactions - ${getCurrentDate()}`,
      headColumns,
    );
  };
  const downloadCSVStyle = {
    padding: '15px 20px 10px 0px',
    cursor: 'pointer',
  };
  const handleSelect = val => {
    const newCurrentFilters = [...currentFilters];
    if (includesOption(newCurrentFilters, val)) {
      const index = indexOfOption(newCurrentFilters, val);
      newCurrentFilters.splice(index, 1);
    } else {
      newCurrentFilters.push(val);
    }
    setCurrentFilters(newCurrentFilters);
  };
  const clearFilters = () => {
    setCurrentFilters([]);
  };

  const closeCreateReportModal = () => {
    setShowCreateReportModal(false);
    clearGenerateReport();
    getInvoiceDetails({ startDate, endDate, flowType: currentFlow });
    getPaymentsForInvoice({ startDate, endDate, flowType: currentFlow });
  };

  return fetchingInvoiceDetails ? (
    <DashboardWrapper>
      <SpinnerHolder className='center'>
        <Spinner color={red.z_red} size='medium' />
      </SpinnerHolder>
    </DashboardWrapper>
  ) : (
    <DashboardWrapper>
      <OnlinePaymentModal
        isInvoiceSelected
        invoice={invoiceDetails}
        closeModal={closeOnlinePaymentModal}
        isVisible={onlinePaymentModal}
        heading='Pay online'
      />
      <CreateReportModal
        title='Generate statement'
        showModal={showCreateReportModal}
        closeModal={closeCreateReportModal}
        invoiceStartDate={startDate}
        iscurrentMonthConsumption
      />
      <BreadCrumbWrapper>
        <Breadcrumb>
          <Breadcrumb.Link
            style={{ color: 'var(--coolgreycoolgrey-400, #AFB4C0)' }}
            linkTo={`${DASHBOARD_ROUTE}#${HOME_ROUTE}`}
          >
            Home
          </Breadcrumb.Link>
          <Breadcrumb.Link
            style={{ color: 'var(--coolgreycoolgrey-400, #AFB4C0)' }}
            linkTo={`${DASHBOARD_ROUTE}#${PAYMENTS_ROUTE}`}
          >
            Payments
          </Breadcrumb.Link>
          <Breadcrumb.Link
            style={{ color: 'var(--coolgreycoolgrey-800, #414A5D)' }}
          >
            Consumption Statement(s)
          </Breadcrumb.Link>
        </Breadcrumb>
      </BreadCrumbWrapper>
      <HeadWrapper style={{ marginTop: '20px' }}>
        <HeadWrapper.Left>
          <H5>
            {' '}
            {getPeriodForInvoice(invoiceDetails.start_date)}
            {' '}
          </H5>
          {isInvoiceGenerated(invoiceDetails.status) && (
            <StatusContainer
              style={{ marginLeft: '10px' }}
              status={invoicesStatusEnum[invoiceDetails.status]}
            >
              {statusLabels[invoicesStatusEnum[invoiceDetails.status]]}
            </StatusContainer>
          )}
        </HeadWrapper.Left>
        <ActionComponent />
      </HeadWrapper>
      {isCurrentMonth(invoiceDetails.start_date) && isDiscountApplied && (
        <>
          <CurrentMonthConsumptionDiscountWrapper>
            {' '}
            <CurrentMonthDiscountMsgIcon>
              {' '}
              <DiscountMsgIcon />
              {' '}
            </CurrentMonthDiscountMsgIcon>
            {' '}
            <CurrentMonthConsumptionDiscountText>
              {' '}
              {`${currentMonthDiscountMSG} ${getMonthAndYearFromDate(
                invoiceDetails.start_date,
                true,
              )}`}
              {' '}
            </CurrentMonthConsumptionDiscountText>
          </CurrentMonthConsumptionDiscountWrapper>
          <CurrentMonthConsumptionDiscountGap />
        </>
      )}
      <LayoutContainers>
        <Layout gap={20}>
          <Layout.Item colD={4} colT={4} colM={4}>
            <DetailsWrapper
              showInfoTip={false}
              tooltipDirection='bottomRight'
              tooltipMessage={invoicePeriodTooltip}
              label='Invoice ID'
              value={invoiceDetails?.invoice_id}
              forInvoice={isDiscountApplied}
            />
          </Layout.Item>
          <Layout.Item colD={4} colT={4} colM={4}>
            <DetailsWrapper
              showInfoTip={false}
              tooltipDirection='bottomRight'
              tooltipMessage={invoiceAmountPayableTooltip}
              label='Amount payable'
              value={
                invoiceDetails?.payable_amount !== ''
                  ? formatAmountInRupees(invoiceDetails?.payable_amount)
                  : ' - '
              }
              subValue={
                isDiscountApplied
                  ? formatAmountInRupees(
                    appliedDiscount?.actual_payable_amount ?? '',
                  )
                  : ''
              }
              forInvoice={isDiscountApplied}
              showDiscount={
                isDiscountApplied && !isCurrentMonth(invoiceDetails.start_date)
              }
              discount={appliedDiscount?.discount_percent ?? ''}
            />
          </Layout.Item>
          <Layout.Item colD={4} colT={4} colM={4}>
            <DetailsWrapper
              showInfoTip={false}
              tooltipDirection='bottomRight'
              tooltipMessage={invoiceAmountPaidTooltip}
              label='Amount paid'
              value={
                invoiceDetails?.paid_amount !== ''
                  ? formatAmountInRupees(invoiceDetails?.paid_amount)
                  : ' - '
              }
              forInvoice={isDiscountApplied}
            />
          </Layout.Item>
        </Layout>
      </LayoutContainers>
      <HeadWrapper>
        <H5>Payments History</H5>
      </HeadWrapper>
      <TabWrapper>
        {!fetchedPaymentsForInvoice ? (
          <ErrorPage
            showAction
            actionLabel={REFRESH_LABEL}
            clickAction={refreshPage}
          />
        ) : (
          <>
            <SearchContainerV2>
              <SearchInput
                leftIcon={<Search />}
                innerWidth='100%'
                value={search}
                onChange={onInputChange}
                onFocus={() => setIsSearchClicked(true)}
                onBlur={() => setIsSearchClicked(false)}
                label={
                  isSearchClicked || disabledSearch || search?.length ? (
                    'Search by UTR/reference no.'
                  ) : (
                    <span style={{ fontSize: '16px', fontWeight: 300 }}>
                      {' '}
                      Search by UTR/reference no.
                      {' '}
                    </span>
                  )
                }
                disabled={disabledSearch}
              />
              <StatusFilterAndExportCSVContainer>
                <StatusFilter
                  isDisabled={disabledSearch}
                  clearFilters={clearFilters}
                  currentFilters={currentFilters}
                  options={filterStatusOptions}
                  handleSelect={handleSelect}
                />
                {disabledSearch ? (
                  <Tooltip
                    position='top'
                    label='Download the payments'
                    appearance='light'
                    size='big'
                    style={{
                      fontSize: '12px',
                      opacity: 0.8,
                      marginRight: '10px',
                      marginLeft: '-30px',
                    }}
                  >
                    <Download
                      color='grey'
                      onClick={exportSearchResultCSV}
                      style={downloadCSVStyle}
                    />
                  </Tooltip>
                ) : (
                  <Download
                    color='grey'
                    style={{ padding: '10px 20px 20px 0px' }}
                  />
                )}
              </StatusFilterAndExportCSVContainer>
            </SearchContainerV2>
            <TableContainer>
              <DataTables
                columns={paymentsCreditsHeadColumn}
                loading={fetchingPaymentsForInvoice || loading}
                data={currentData}
                pagination
                totalRows={searchResults ? searchResults.length : 0}
                handlePageChange={handlePageChange}
                onSort={handleSort}
                emptyStateTitle='No transaction data'
              />
            </TableContainer>
          </>
        )}
      </TabWrapper>
    </DashboardWrapper>
  );
};

InvoiceDetails.propTypes = {
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
  invoiceDetails: PropTypes.objectOf(PropTypes.any),
  appliedDiscount: PropTypes.objectOf(PropTypes.any),
  getInvoiceDetails: PropTypes.func,
  fetchingInvoiceDetails: PropTypes.bool,
  paymentsForInvoice: PropTypes.arrayOf(PropTypes.any),
  getPaymentsForInvoice: PropTypes.func,
  fetchingPaymentsForInvoice: PropTypes.bool,
  fetchedPaymentsForInvoice: PropTypes.bool,
  showErrorToast: PropTypes.func,
  clearGenerateReport: PropTypes.func,
  viewOnlyMode: PropTypes.bool,
};

InvoiceDetails.defaultProps = {
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_LIMIT,
  invoiceDetails: {},
  appliedDiscount: {},
  getInvoiceDetails: noop,
  fetchingInvoiceDetails: false,
  paymentsForInvoice: [],
  getPaymentsForInvoice: noop,
  fetchingPaymentsForInvoice: false,
  fetchedPaymentsForInvoice: false,
  showErrorToast: noop,
  clearGenerateReport: noop,
  viewOnlyMode: false,
};

export default InvoiceDetails;
